/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./scripts/components/collection/collection.js":
/*!*****************************************************!*\
  !*** ./scripts/components/collection/collection.js ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component(function (node, ctx) {
  var _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(node, null),
    productGrid = _choozy.productGrid,
    loadPreviousButton = _choozy.loadPreviousButton,
    loadNextButton = _choozy.loadNextButton,
    productsJson = _choozy.productsJson,
    paginationJson = _choozy.paginationJson,
    productsShown = _choozy.productsShown,
    productsCount = _choozy.productsCount;
  var _JSON$parse = JSON.parse(paginationJson.innerHTML),
    pagination = _JSON$parse.pagination;
  window.addEventListener('popstate', function () {
    // Reload every time the back button is clicked to prevent "load more" button confusion
    window.location.reload();
  }, false);
  ctx.emit('product-data:set', null, {
    products: productsJson ? JSON.parse(productsJson.innerHTML).products : []
  });
  var fetchCollectionPage = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(url) {
      var response, text, html;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(url);
          case 2:
            response = _context.sent;
            _context.next = 5;
            return response.text();
          case 5:
            text = _context.sent;
            if (response.ok) {
              _context.next = 10;
              break;
            }
            console.error('Error occured when fetching products: ', response.status);
            _context.next = 12;
            break;
          case 10:
            html = new DOMParser().parseFromString(text, 'text/html');
            return _context.abrupt("return", html);
          case 12:
            return _context.abrupt("return", null);
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function fetchCollectionPage(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  /* eslint-disable camelcase */
  var updateProductsShownValue = function updateProductsShownValue() {
    // This function changes the value of the products shown counter
    var current_page = pagination.current_page,
      collection_products_count = pagination.collection_products_count,
      current_page_size = pagination.current_page_size,
      current_offset = pagination.current_offset,
      pages = pagination.pages;
    var productsShownValue;
    switch (true) {
      // when you're on the first page and there are less than 10 products
      case current_page === 1 && collection_products_count <= current_page_size:
        productsShownValue = collection_products_count;
        break;
      // when you're on the first page and there are more than 10 products
      case current_page === 1 && collection_products_count > current_page_size:
        productsShownValue = current_page_size;
        document.querySelector('.page-load-status').style.display = 'block';
        break;
      // when you're on the last page
      case current_page === pages:
        document.querySelector('.page-load-status').style.display = 'none';
        document.querySelector('.infinite-scroll-last').style.display = 'block';
        productsShownValue = collection_products_count;
        break;
      // when you're not on the first or last page
      default:
        productsShownValue = current_offset + current_page_size;
    }
    productsShown.innerHTML = productsShownValue;
  };
  var updateProductsCountValue = function updateProductsCountValue() {
    // This function changes the value of the products total counter
    var collection_products_count = pagination.collection_products_count;
    var productsCountValue = collection_products_count;
    productsCount.innerHTML = productsCountValue;
  };
  var updateInfinitePagination = function updateInfinitePagination() {
    var current_page = pagination.current_page,
      collection_products_count = pagination.collection_products_count,
      current_page_size = pagination.current_page_size,
      current_offset = pagination.current_offset,
      pages = pagination.pages;
    if (current_page == pages) {
      document.querySelector('.page-load-status').style.display = 'none';
      document.querySelector('.infinite-scroll-last').style.display = 'block';
    } else {
      document.querySelector('.page-load-status').style.display = 'block';
      document.querySelector('.infinite-scroll-last').style.display = 'none';
    }
    handleProductClick();
  };
  var updatePaginationButtonsOnFilterActive = function updatePaginationButtonsOnFilterActive(newPageHtml) {
    // This function updates the pagination buttons when a filter is active
    var _choozy2 = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(newPageHtml, null),
      newPaginationJson = _choozy2.paginationJson;

    // we retrieve the new pagination object from the new html and update the existing pagination object in javascript
    var _JSON$parse2 = JSON.parse(newPaginationJson.innerHTML),
      newPagination = _JSON$parse2.pagination;
    pagination.current_page = newPagination.current_page;
    pagination.current_offset = newPagination.current_offset;
    pagination.current_page_size = newPagination.current_page_size;
    pagination.collection_products_count = newPagination.collection_products_count; // Shopify automatically updates this with filter active
    pagination.pages = newPagination.pages;
    updateProductsShownValue();
    updateProductsCountValue();
  };
  var resetPaginationButtons = function resetPaginationButtons(newPageHtml) {
    // This function resets the pagination buttons when a filter is (in)active
    var _choozy3 = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(newPageHtml, null),
      newLoadPreviousButton = _choozy3.loadPreviousButton,
      newLoadNextButton = _choozy3.loadNextButton;
    var current_page = pagination.current_page,
      pages = pagination.pages;
    var isNewLoadPreviousButton = !newLoadPreviousButton.classList.contains('hidden-tw');
    var isNewLoadNextButton = !newLoadNextButton.classList.contains('hidden-tw');
    if (current_page == pages) {
      document.querySelector('.page-load-status').style.display = 'none';
      document.querySelector('.infinite-scroll-last').style.display = 'block';
    } else {
      document.querySelector('.page-load-status').style.display = 'block';
      document.querySelector('.infinite-scroll-last').style.display = 'none';
    }

    // if there is a load next button, we update the existing button's target page number with the new target page number
    if (isNewLoadNextButton) {
      loadNextButton.dataset.targetPageNumber = newLoadNextButton.dataset.targetPageNumber;
      loadNextButton.classList.remove('hidden-tw');
    } else {
      loadNextButton.classList.add('hidden-tw');
    }
    if (isNewLoadPreviousButton) {
      loadPreviousButton.dataset.targetPageNumber = newLoadPreviousButton.dataset.targetPageNumber;
      loadPreviousButton.classList.remove('hidden-tw');
    } else {
      loadPreviousButton.classList.add('hidden-tw');
    }
  };
  var renderPaginationButtons = function renderPaginationButtons(isLoadNext, newPageHtml) {
    // This function renders the pagination buttons
    var _choozy4 = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(newPageHtml, null),
      newLoadPreviousButton = _choozy4.loadPreviousButton,
      newLoadNextButton = _choozy4.loadNextButton,
      newPaginationJson = _choozy4.paginationJson;

    // we retrieve the new pagination object from the new html and update the existing pagination object in javascript
    var _JSON$parse3 = JSON.parse(newPaginationJson.innerHTML),
      newPagination = _JSON$parse3.pagination;
    pagination.current_page = newPagination.current_page;
    pagination.pages = newPagination.pages;
    pagination.collection_products_count = newPagination.collection_products_count; // Shopify automatically updates this with filter active
    if (isLoadNext) {
      pagination.current_page_size = newPagination.current_page_size;
    } else {
      // if we're going to previous page
      // we need to add the difference between the current offset and the lesser new offset to the current_page_size
      pagination.current_page_size += pagination.current_offset - newPagination.current_offset;
    }
    pagination.current_offset = newPagination.current_offset;
    updateProductsShownValue();

    // if the button is visible
    var isNewLoadPreviousButton = !newLoadPreviousButton.classList.contains('hidden-tw');
    var isNewLoadNextButton = !newLoadNextButton.classList.contains('hidden-tw');

    // if the button clicked is the load next button AND there is a new load next button
    // we update the existing button's target page number with the new target page number
    if (isLoadNext && isNewLoadNextButton) {
      loadNextButton.dataset.targetPageNumber = newLoadNextButton.dataset.targetPageNumber;
    } else if (isLoadNext && !isNewLoadNextButton) {
      loadNextButton.classList.add('hidden-tw');
    } else if (!isLoadNext && isNewLoadPreviousButton) {
      loadPreviousButton.dataset.targetPageNumber = newLoadPreviousButton.dataset.targetPageNumber;
    } else {
      loadPreviousButton.classList.add('hidden-tw');
    }
  };
  var sections = {
    selectedVariant: 'test',
    ajaxinateContainer: '#AjaxinateContainer',
    ajaxinatePagination: '#AjaxinatePagination',
    ajaxinateId: 'data-ajaxinate-id',
    isLoaded: 'is-loaded'
  };
  var isFetching = false; // Flag to prevent multiple fetches at once

  var renderMoreProducts = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
      var targetButton, isLoadNext, targetPageNumber, urlParams, newPageHtml, _choozy5, newProductGrid, newProductsJson;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!isFetching) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return", false);
          case 2:
            // Prevent multiple fetches
            // This function renders more products when the load next or previous button is clicked
            targetButton = event.currentTarget; // the click event of the previous or next button
            isLoadNext = targetButton === loadNextButton; // if false, it's the previous button
            targetPageNumber = event.currentTarget.dataset.targetPageNumber; // the page number to load, minus or plus 1
            urlParams = new URLSearchParams(window.location.search);
            targetButton.classList.add('open');
            urlParams.set('page', targetPageNumber);

            // this makes a fetch call to shopify to get new html for the additional products
            _context2.next = 10;
            return fetchCollectionPage("".concat(window.location.origin + window.location.pathname, "?section_id=main-collection&").concat(urlParams));
          case 10:
            newPageHtml = _context2.sent;
            _choozy5 = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(newPageHtml, null), newProductGrid = _choozy5.productGrid, newProductsJson = _choozy5.productsJson;
            renderPaginationButtons(isLoadNext, newPageHtml);
            productGrid.insertAdjacentHTML(isLoadNext ? 'beforeend' : 'afterbegin', newProductGrid.innerHTML);
            window.app.mount();
            ctx.emit('product-data:set', null, {
              products: newProductsJson ? JSON.parse(newProductsJson.innerHTML).products : {}
            });

            // eslint-disable-next-line no-restricted-globals
            history.pushState({}, '', "".concat(window.location.origin + window.location.pathname, "?").concat(urlParams));
            isFetching = false;
            updateInfinitePagination();

            // eslint-disable-next-line no-unused-expressions
            targetButton === null || targetButton === void 0 || targetButton.classList.remove('open');
          case 20:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function renderMoreProducts(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  [].concat(loadPreviousButton, loadNextButton).forEach(function (loadMoreButton) {
    // eslint-disable-next-line no-unused-expressions
    loadMoreButton === null || loadMoreButton === void 0 || loadMoreButton.addEventListener('click', renderMoreProducts);
  });
  // Debounce function to limit how often the scroll event can trigger
  // Intersection Observer to trigger click when .load-more-btn-inf enters the viewport
  var loadMoreObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting && !isFetching) {
        console.log('load-more-btn-inf is in viewport, loading more products');
        loadNextButton.click(); // Trigger a click on the loadNextButton to load more products
      }
    });
  }, {
    root: null,
    // Use the viewport as the root
    rootMargin: '0px',
    threshold: 0.1 // Trigger when at least 10% of the element is visible
  });

  // Start observing the .load-more-btn-inf element
  var loadMoreBtnInf = document.querySelector('.load-more-btn-inf');
  if (loadMoreBtnInf) {
    loadMoreObserver.observe(loadMoreBtnInf);
  }
  ctx.on('filter:render', function (_ref3) {
    var html = _ref3.html;
    updatePaginationButtonsOnFilterActive(html);
    resetPaginationButtons(html);
  });
  console.log('webpack tes2t');
  updateProductsShownValue();
  updateInfinitePagination();
  function handleProductClick(event) {
    var productItems = document.querySelectorAll('.single-product-item a');
    productItems.forEach(function (item) {
      var variantId = item.getAttribute('data-default-variant-id');
      var productUrl = item.getAttribute('data-url');
      var pageNumber = item.getAttribute('data-current-page-number');
      item.addEventListener('click', function (event) {
        event.preventDefault();
        setHistory(variantId, pageNumber, productUrl);
        sessionStorage.setItem('scrollPosition', 0);
      });
    });
  }
  handleProductClick();

  // Function to update browser history
  function setHistory(productId, page, productUrl) {
    var currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('page', page);
    history.pushState(null, '', currentUrl);
    setTimeout(function () {
      window.location.href = productUrl;
    }, 0);
  }
}));

/***/ }),

/***/ "./scripts/components/collection/components.js":
/*!*****************************************************!*\
  !*** ./scripts/components/collection/components.js ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./filter */ "./scripts/components/collection/filter.js");
/* harmony import */ var _collection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./collection */ "./scripts/components/collection/collection.js");
/* harmony import */ var _product_product_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../product/product-form */ "./scripts/components/product/product-form.js");



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  collectionFilter: _filter__WEBPACK_IMPORTED_MODULE_0__["default"],
  collection: _collection__WEBPACK_IMPORTED_MODULE_1__["default"],
  productForm: _product_product_form__WEBPACK_IMPORTED_MODULE_2__["default"]
});
console.log('components.est');

/***/ }),

/***/ "./scripts/components/collection/filter.js":
/*!*************************************************!*\
  !*** ./scripts/components/collection/filter.js ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

var fetchHtml = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(url) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", fetch(url).then(function (response) {
            return response.text();
          }).then(function (responseText) {
            return new DOMParser().parseFromString(responseText, 'text/html');
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchHtml(_x) {
    return _ref.apply(this, arguments);
  };
}();
var updateURLHash = function updateURLHash(searchParams) {
  return (
    // eslint-disable-next-line no-restricted-globals
    history.pushState({
      searchParams: searchParams
    }, '', "".concat(window.location.pathname).concat(searchParams !== null && searchParams !== void 0 && searchParams.includes('?') ? searchParams : '?'.concat(searchParams)))
  );
};
var fetchFilterSection = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(searchParams, section) {
    var filterHtmlRender;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return fetchHtml("".concat(window.location.origin + window.location.pathname, "?section_id=").concat(section.id, "&").concat(searchParams));
        case 2:
          filterHtmlRender = _context2.sent;
          window.app.emit(['filter:render'], {
            html: filterHtmlRender,
            uri: searchParams
          });
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function fetchFilterSection(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component(function (node, ctx) {
  var _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(node, null),
    toggleFilter = _choozy.toggleFilter,
    drawerOpen = _choozy.drawerOpen;
  var el = node;
  var updateSection = function updateSection(section, html) {
    el.querySelector(section).innerHTML = html.querySelector(section).innerHTML;
  };
  var section = {
    id: node.dataset.sectionId,
    grid: '[data-product-grid]',
    sort: '[data-sort]',
    count: '[data-product-count]',
    drawerCount: '[data-drawer-product-count]',
    priceInput: '[data-price-input]',
    rangeWrapper: '[data-range-wrapper]',
    form: '[data-form-container]',
    active: '[data-active-filters]',
    input: '[data-input]',
    clear: '[data-clear-all]',
    container: '[data-filter-container]',
    categoryFilterControls: '[data-category-filter]',
    sizeFilterControls: '[data-size-filter]',
    colorFilterControls: '[data-color-filter]',
    priceFilterControls: '[data-price-filter]',
    selectedVariant: 'test',
    ajaxinateContainer: '#AjaxinateContainer',
    ajaxinatePagination: '#AjaxinatePagination',
    ajaxinateId: 'data-ajaxinate-id',
    isLoaded: 'is-loaded'
  };
  var clearListener = function clearListener() {
    var _ref3;
    (_ref3 = []).concat.apply(_ref3, _toConsumableArray(el.querySelectorAll(section.clear))).forEach(function (clear) {
      return clear.addEventListener('click', /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(e) {
          var filterHtmlRender;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                e.preventDefault();
                _context3.next = 3;
                return fetchHtml("".concat(window.location.origin + window.location.pathname, "?section_id=").concat(section.id));
              case 3:
                filterHtmlRender = _context3.sent;
                window.app.emit(['filter:render'], {
                  html: filterHtmlRender,
                  uri: ''
                });
              case 5:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return function (_x4) {
          return _ref4.apply(this, arguments);
        };
      }());
    });
  };
  clearListener();
  var filterInputEventHandler = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(e) {
      var formFilters, searchParams, filterControlsHtmlRender;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            el.querySelector(section.container).classList.add('pointer-events-none', 'opacity-50');
            formFilters = new URLSearchParams(new FormData(e.target.closest('form'))).toString();
            fetchFilterSection(formFilters, section);
            searchParams = new URLSearchParams(new FormData(e.target.closest('form'))).toString();
            _context4.next = 6;
            return fetchHtml("".concat(window.location.origin + window.location.pathname, "?section_id=").concat(section.id, "&").concat(searchParams));
          case 6:
            filterControlsHtmlRender = _context4.sent;
            window.app.emit(['filter:render'], {
              html: filterControlsHtmlRender
            });
          case 8:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function filterInputEventHandler(_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
  var updateFilterControls = function updateFilterControls() {
    el.querySelectorAll(section.input).forEach(function (eachInput) {
      return eachInput.addEventListener('input', function (e) {
        return filterInputEventHandler(e);
      });
    });
    el.querySelectorAll(section.priceInput).forEach(function (eachInput) {
      return eachInput.addEventListener('mouseup', /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(e) {
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", filterInputEventHandler(e));
              case 1:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        return function (_x6) {
          return _ref6.apply(this, arguments);
        };
      }());
    });
    el.querySelectorAll(section.sort).forEach(function (eachInput) {
      return eachInput.addEventListener('change', /*#__PURE__*/function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(e) {
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", filterInputEventHandler(e));
              case 1:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        }));
        return function (_x7) {
          return _ref7.apply(this, arguments);
        };
      }());
    });
  };
  updateFilterControls();
  var addSliderListeners = function addSliderListeners(html) {
    var _ref8, _ref9, _ref10;
    var trueMinForMax = parseInt((_ref8 = html || el) === null || _ref8 === void 0 || (_ref8 = _ref8.querySelector(section.rangeWrapper)) === null || _ref8 === void 0 || (_ref8 = _ref8.dataset) === null || _ref8 === void 0 ? void 0 : _ref8.trueMinForMax, 0);
    var trueMaxForMin = parseInt((_ref9 = html || el) === null || _ref9 === void 0 || (_ref9 = _ref9.querySelector(section.rangeWrapper)) === null || _ref9 === void 0 || (_ref9 = _ref9.dataset) === null || _ref9 === void 0 ? void 0 : _ref9.trueMaxForMin, 0);
    var priceGap = parseInt(node.dataset.priceGap, 0);
    var rangeInput = el.querySelectorAll(section.priceInput);
    (_ref10 = []).concat.apply(_ref10, _toConsumableArray(rangeInput)).forEach(function (rangeI) {
      rangeI.addEventListener('input', function (e) {
        e.target.parentNode.style.setProperty("--".concat(e.target.id), +e.target.value);
        var lower = rangeInput[0];
        var lowerVal = parseInt(lower.value, 0);
        var lowerMax = parseInt(lower.min, 0);
        var upper = rangeInput[1];
        var upperVal = parseInt(upper.value, 0);
        var upperMax = parseInt(upper.max, 0);
        if (trueMinForMax < priceGap) trueMinForMax = priceGap;
        if (trueMaxForMin > upperMax - priceGap) trueMaxForMin = upperMax - priceGap;
        if (e.target.id === 'lower') {
          if (lower.value > upperVal - priceGap) {
            upper.value = lowerVal + priceGap;
            e.target.parentNode.style.setProperty("--upper", lowerVal + priceGap);
            if (lowerVal > upperVal - priceGap && upperVal >= upperMax) {
              lower.value = upperMax - priceGap;
              upper.value = upperMax;
              e.target.parentNode.style.setProperty('--lower', upperMax - priceGap);
              e.target.parentNode.style.setProperty('--upper', upperMax);
            }
          }
          if (lowerVal > trueMaxForMin) {
            lower.value = trueMaxForMin;
            e.target.parentNode.style.setProperty("--lower", trueMaxForMin);
          }
        } else if (e.target.id === 'upper') {
          if (upperVal < lowerVal + priceGap) {
            lower.value = upperVal - priceGap;
            e.target.parentNode.style.setProperty("--lower", upperVal - priceGap);
            if (lowerVal <= lowerMax) {
              upper.value = priceGap;
              lower.value = lowerMax;
              e.target.parentNode.style.setProperty("--upper", priceGap);
              e.target.parentNode.style.setProperty('--lower', lowerMax);
            }
          }
          if (upperVal < trueMinForMax) {
            upper.value = trueMinForMax;
            e.target.parentNode.style.setProperty("--upper", trueMinForMax);
          }
        }
      });
    });
  };
  addSliderListeners();
  ctx.on('filter:render', function (_ref11) {
    var html = _ref11.html,
      uri = _ref11.uri;
    console.log('test render');
    updateSection(section.grid, html);
    updateSection(section.categoryFilterControls, html);
    updateSection(section.sizeFilterControls, html);
    updateSection(section.colorFilterControls, html);
    updateSection(section.priceFilterControls, html);
    updateSection(section.sort, html);
    updateSection(section.count, html);
    updateSection(section.drawerCount, html);
    updateSection(section.active, html);
    clearListener();
    updateFilterControls();
    addSliderListeners(html);
    updateURLHash(uri);
    el.querySelector(section.container).classList.remove('pointer-events-none', 'opacity-50');
    window.app.mount();
  });

  // Open/Close filters
  [].concat(toggleFilter).forEach(function (toggle) {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      drawerOpen.classList.toggle('open');
      ctx.emit('body:toggleScroll', function () {
        return {
          enable: drawerOpen.classList.contains('open')
        };
      });
    });
  });
}));

/***/ }),

/***/ "./scripts/components/product/product-form.js":
/*!****************************************************!*\
  !*** ./scripts/components/product/product-form.js ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_cart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/cart */ "./scripts/lib/cart.js");
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");
/* harmony import */ var _lib_is_different_variant__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../lib/is-different-variant */ "./scripts/lib/is-different-variant.js");
/* harmony import */ var _lib_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../lib/string */ "./scripts/lib/string.js");
/* harmony import */ var _lib_subscribe_to_notifications__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../lib/subscribe-to-notifications */ "./scripts/lib/subscribe-to-notifications.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/* eslint-disable no-prototype-builtins */





var emailRegEx = new RegExp(/\S+@\S+\.\S+/);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component(function (node, ctx) {
  var _document$querySelect, _sizeChartBtn$dataset;
  var _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_1__["default"])(node, null),
    submit = _choozy.submit,
    submitText = _choozy.submitText,
    notifyEmail = _choozy.notifyEmail,
    notifyMeBtn = _choozy.notifyMeBtn,
    sizeChartBtn = _choozy.sizeChartBtn;
  var currentVariant = null;
  ctx.on('variant:change', function (_, _ref) {
    var product = _ref.product,
      selectedVariant = _ref.selectedVariant,
      _ref$isWishlistItem = _ref.isWishlistItem,
      isWishlistItem = _ref$isWishlistItem === void 0 ? false : _ref$isWishlistItem;
    if ((0,_lib_is_different_variant__WEBPACK_IMPORTED_MODULE_2__["default"])({
      productId: product.id.toString(),
      data: node.dataset,
      isWishlistItem: isWishlistItem
    })) return;
    currentVariant = selectedVariant;
  });
  var addToCart = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(variant) {
      var _yield$addVariant, error;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            submit.disabled = true;
            submitText.textContent = (0,_lib_string__WEBPACK_IMPORTED_MODULE_3__.getString)('product.adding_to_cart');
            _context.next = 4;
            return (0,_lib_cart__WEBPACK_IMPORTED_MODULE_0__.addVariant)(variant, 1);
          case 4:
            _yield$addVariant = _context.sent;
            error = _yield$addVariant.error;
            // eslint-disable-next-line no-alert
            if (error) alert(error);
            submit.disabled = true;
            submitText.textContent = (0,_lib_string__WEBPACK_IMPORTED_MODULE_3__.getString)('product.added_to_cart');
            ctx.emit('quick-add:success');
            setTimeout(function () {
              if (!error) ctx.emit('cart:toggle', {
                cartOpen: true
              });
            }, 0);
            setTimeout(function () {
              submit.disabled = false;
              submitText.textContent = (0,_lib_string__WEBPACK_IMPORTED_MODULE_3__.getString)('product.add_to_cart');
            }, error ? 0 : 1000);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function addToCart(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var openNotifyForm = function openNotifyForm() {
    notifyMeBtn.disabled = true;
    node.classList.add('is-visible');
  };
  var closeNotifyForm = function closeNotifyForm() {
    notifyMeBtn.disabled = false;
    notifyEmail.value = '';
    node.classList.remove('is-visible', 'is-success');
  };
  notifyEmail.addEventListener('input', function (e) {
    var value = e.target.value;
    var isValid = value && node.classList.contains('is-visible') && emailRegEx.test(value);
    notifyMeBtn.disabled = !isValid;
  });
  notifyMeBtn.addEventListener('click', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0,_lib_subscribe_to_notifications__WEBPACK_IMPORTED_MODULE_4__["default"])(notifyEmail.value, currentVariant.id);
        case 3:
          node.classList.add('is-success');
          setTimeout(closeNotifyForm, 1500);
          _context2.next = 10;
          break;
        case 7:
          _context2.prev = 7;
          _context2.t0 = _context2["catch"](0);
          console.error(_context2.t0);
        case 10:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 7]]);
  })));
  var onOpenNotifyForm = function onOpenNotifyForm() {
    openNotifyForm();
    if (!currentVariant.option2) return;
    ctx.emit('size-modal:update', null, {
      size: currentVariant.option2
    });
  };
  node.addEventListener('submit', function (e) {
    e.preventDefault();
    if (currentVariant.available) {
      addToCart(currentVariant);
      return;
    }
    if (!node.classList.contains('is-visible')) {
      onOpenNotifyForm();
    }
  });
  ctx.on(['toggleSizeSelect', 'mobile-pdp:close', 'quick-add:close'], function (_ref4) {
    var sizeSelectOpen = _ref4.sizeSelectOpen;
    if (!sizeSelectOpen) {
      setTimeout(function () {
        ctx.emit('size-modal:update', null, {
          size: null
        });
        closeNotifyForm();
      }, 300);
    }
  });

  /**
   * Size chart button
   */
  var sizeChartTypes = ((_document$querySelect = document.querySelector('#size-chart')) === null || _document$querySelect === void 0 || (_document$querySelect = _document$querySelect.dataset) === null || _document$querySelect === void 0 || (_document$querySelect = _document$querySelect.chartTypes) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.split(',')) || [];
  var productTags = (sizeChartBtn === null || sizeChartBtn === void 0 || (_sizeChartBtn$dataset = sizeChartBtn.dataset) === null || _sizeChartBtn$dataset === void 0 || (_sizeChartBtn$dataset = _sizeChartBtn$dataset.productTags) === null || _sizeChartBtn$dataset === void 0 ? void 0 : _sizeChartBtn$dataset.split(',')) || [];
  var chartType = productTags.find(function (tag) {
    return sizeChartTypes.includes(tag);
  });
  if (chartType) {
    sizeChartBtn.style.visibility = 'visible';
    sizeChartBtn.addEventListener('click', function (e) {
      e.preventDefault();
      ctx.emit('sizeChartToggle', function (_ref5) {
        var showSizeChart = _ref5.showSizeChart,
          sizeChartType = _ref5.sizeChartType;
        return {
          showSizeChart: true,
          sizeChartType: chartType
        };
      });
    });
  }
}));

/***/ }),

/***/ "./scripts/lib/cart.js":
/*!*****************************!*\
  !*** ./scripts/lib/cart.js ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   addItemsById: () => (/* binding */ addItemsById),
/* harmony export */   addVariant: () => (/* binding */ addVariant),
/* harmony export */   clearCart: () => (/* binding */ clearCart),
/* harmony export */   fetchCart: () => (/* binding */ fetchCart),
/* harmony export */   fetchCartMarkup: () => (/* binding */ fetchCartMarkup),
/* harmony export */   removeAddon: () => (/* binding */ removeAddon),
/* harmony export */   updateAddon: () => (/* binding */ updateAddon)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function fetchCart() {
  return fetch("".concat(window.Phill.routes.cart, ".js"), {
    method: 'GET',
    credentials: 'include'
  }).then(function (res) {
    return res.json();
  });
}
function fetchCartMarkup() {
  return fetch("".concat(window.Phill.routes.cart, "?sections=cart-drawer"), {
    method: 'GET',
    credentials: 'include'
  }).then(function (res) {
    return res.json();
  });
}
function changeAddon(id, quantity) {
  window.app.emit('cart:updating');
  return fetch("".concat(window.Phill.routes.cartChange, ".js"), {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: id,
      quantity: quantity,
      sections: 'cart-drawer'
    })
  }).then(function (res) {
    return res.json();
  }).then( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(cart) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            window.app.emit(['cart:updated', 'cart:render'], {
              cart: cart
            });
            return _context.abrupt("return", cart);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
}
function clearCart() {
  window.app.emit('cart:updating');
  return fetch("".concat(window.Phill.routes.cartClear, ".js"), {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      sections: 'cart-drawer'
    })
  }).then(function (r) {
    return r.json();
  }).then(function (cart) {
    window.app.emit(['cart:updated', 'cart:render'], {
      cart: cart
    });
    return cart;
  });
}
function addItemsById() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  window.app.emit('cart:updating');
  console.log('wow');
  return fetch("".concat(window.Phill.routes.cartAdd, ".js"), {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      items: items
    })
  }).then(function (r) {
    return r.json();
  }).then( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(item) {
      var _yield$Promise$all, _yield$Promise$all2, cart, cartMarkup;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!item.status) {
              _context2.next = 3;
              break;
            }
            window.app.emit(['cart:updated', 'cart:error'], null, item);
            return _context2.abrupt("return", {
              item: item,
              cart: window.app.getState().cart,
              error: item === null || item === void 0 ? void 0 : item.description
            });
          case 3:
            _context2.next = 5;
            return Promise.all([fetchCart(), fetchCartMarkup()]);
          case 5:
            _yield$Promise$all = _context2.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            cart = _yield$Promise$all2[0];
            cartMarkup = _yield$Promise$all2[1];
            cart.sections = cartMarkup;
            window.app.emit(['cart:updated', 'cart:render'], {
              cart: cart
            });
            return _context2.abrupt("return", {
              item: item,
              cart: cart
            });
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }());
}
function addVariant(variant, quantity) {
  var properties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return addItemsById([{
    id: variant.id,
    quantity: quantity,
    properties: properties
  }]);
}
function updateAddon(key, quantity) {
  return changeAddon(key, quantity);
}
function removeAddon(key) {
  return updateAddon(key, 0);
}

/***/ }),

/***/ "./scripts/lib/choozy.js":
/*!*******************************!*\
  !*** ./scripts/lib/choozy.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* export default binding */ __WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/* eslint-disable */
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__() {
  var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'js-';
  var elements = _toConsumableArray(container.querySelectorAll(!prefix ? '*' : "[class*=\"".concat(prefix, "\"]")));
  var property = !prefix ? 'dataset' : 'classList';
  return elements.reduce(function (res, el) {
    [].slice.call(!prefix ? Object.entries(el[property]) : el[property]).forEach(function (property) {
      var key;
      if (prefix && property.slice(0, prefix.length) === prefix) key = property.slice(prefix.length, property.length);else if (!prefix) {
        var _property = _slicedToArray(property, 1);
        key = _property[0];
      }
      if (key) {
        res[key] = res.hasOwnProperty(key) ? res[key].constructor === Array ? res[key].concat(el) : [res[key], el] : el;
      }
    });
    return res;
  }, {});
}

/***/ }),

/***/ "./scripts/lib/is-different-variant.js":
/*!*********************************************!*\
  !*** ./scripts/lib/is-different-variant.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* eslint-disable no-prototype-builtins */
// We need this check if the same item is on PDP, PLP and Wishlist: so their local state won't be messed up
// TODO: add search check (if the same item is on PDP and search results)
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (function (_ref) {
  var productId = _ref.productId,
    data = _ref.data,
    isWishlistItem = _ref.isWishlistItem;
  return productId !== data.productId || isWishlistItem && !data.hasOwnProperty('wishlistItem') || !isWishlistItem && data.hasOwnProperty('wishlistItem');
});

/***/ }),

/***/ "./scripts/lib/string.js":
/*!*******************************!*\
  !*** ./scripts/lib/string.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getCamelCase: () => (/* binding */ getCamelCase),
/* harmony export */   getString: () => (/* binding */ getString),
/* harmony export */   toCamelCase: () => (/* binding */ toCamelCase)
/* harmony export */ });
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var toCamelCase = function camalize(str) {
  return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function (m, chr) {
    return chr.toUpperCase();
  });
};
var getCamelCase = function getCamelCase(obj) {
  return Object.entries(obj).reduce(function (o, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    var object = o;
    object[toCamelCase(key)] = value;
    return object;
  }, {});
};
var getString = function getString(string) {
  var _window;
  /**
   * Get string from window.Phill.theme.strings
   * @param {String} string seperate keys, by . just like in liquid
   */

  return string.split('.').reduce(function (obj, str) {
    return obj === null || obj === void 0 ? void 0 : obj[str];
  }, (_window = window) === null || _window === void 0 || (_window = _window.Phill) === null || _window === void 0 || (_window = _window.theme) === null || _window === void 0 ? void 0 : _window.strings) || "Missing translation for ".concat(string, " in window.Phill");
};

/***/ }),

/***/ "./scripts/lib/subscribe-to-notifications.js":
/*!***************************************************!*\
  !*** ./scripts/lib/subscribe-to-notifications.js ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var subscribeToNotifications = function subscribeToNotifications(email, variant) {
  return fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
    method: 'POST',
    mode: 'no-cors',
    body: new URLSearchParams({
      a: 'WdAbii',
      email: email,
      platform: 'shopify',
      variant: variant
    })
  }).then(function (res) {
    if (res.type === 'opaque') {
      return {
        success: true
      };
    }
    throw new Error('Something went wrong');
  });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (subscribeToNotifications);

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/*!************************************!*\
  !*** ./scripts/util/collection.js ***!
  \************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_collection_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../components/collection/components */ "./scripts/components/collection/components.js");

window.app.add(_components_collection_components__WEBPACK_IMPORTED_MODULE_0__["default"]);
window.app.mount();
/******/ })()
;